import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "columnsFilled",
  "use": "columnsFilled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"inherit\" xmlns=\"http://www.w3.org/2000/svg\" id=\"columnsFilled\">\n<path d=\"M11.25 3H6.25C4.7335 3 3.5 4.234 3.5 5.75V18.25C3.5 19.766 4.7335 21 6.25 21H11.25V3ZM17.75 3H12.75V21H17.75C19.2665 21 20.5 19.766 20.5 18.25V5.75C20.5 4.234 19.2665 3 17.75 3Z\" fill=\"inherit\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol